import { useEffect, useState } from 'react';

let online = typeof navigator !== 'undefined' ? navigator.onLine : true;

const listeners = new Set<(online: boolean, previous: boolean) => void>();

function notify(next: boolean): void {
  const previous = online;
  if (next === previous) {
    return;
  }
  online = next;
  listeners.forEach((listener) => listener(next, previous));
}

export function isOnline(): boolean {
  return online;
}

export function subscribeOnlineStatus(
  listener: (online: boolean, previous: boolean) => void,
): () => void {
  listeners.add(listener);
  if (typeof window === 'undefined') {
    return () => listeners.delete(listener);
  }

  const onOnline = () => notify(true);
  const onOffline = () => notify(false);
  window.addEventListener('online', onOnline);
  window.addEventListener('offline', onOffline);

  return () => {
    listeners.delete(listener);
    window.removeEventListener('online', onOnline);
    window.removeEventListener('offline', onOffline);
  };
}

export function useOnlineStatus(): boolean {
  const [status, setStatus] = useState(isOnline());

  useEffect(() => {
    return subscribeOnlineStatus((next) => setStatus(next));
  }, []);

  return status;
}
